import { ReactNode, useContext } from "react";
import Icon from "./icon";
import { NavContext } from "@/context/navContext";
import { useTranslations } from "next-intl";

export default function SectionTitle(
    { children, type, shortCut, className }: 
    { children: ReactNode, type?: string, shortCut?: string, className?:string }
) {
    const { movePage } = useContext(NavContext)
    const t = useTranslations('Text')

    return (
        <div className={`section-title ${className? className : '' }`}>
            <div className="tab">
                { type && <span className={`--menu ${type}`}></span> }
                {children}
            </div>
            {
                shortCut
                    ? <div onClick={e=> movePage(shortCut)} className="more">
                        {/* <Icon icon={`more`} /> */}
                        {t(`더보기`)} +
                    </div>
                    : <></>
            }
        </div>
    )
}